export const GET_OPERATOR_TRIP_DETAILS_START = "GET_OPERATOR_TRIP_DETAILS_START";
export const GET_OPERATOR_TRIP_DETAILS_SUCCESS = "GET_OPERATOR_TRIP_DETAILS_SUCCESS";
export const GET_OPERATOR_TRIP_DETAILS_ERROR = "GET_OPERATOR_TRIP_DETAILS_ERROR";

export const GET_OPERATOR_TRIP_INQUIRY_LIST_START = "GET_OPERATOR_TRIP_INQUIRY_LIST_START";
export const GET_OPERATOR_TRIP_INQUIRY_LIST_SUCCESS = "GET_OPERATOR_TRIP_INQUIRY_LIST_SUCCESS";
export const GET_OPERATOR_TRIP_INQUIRY_LIST_ERROR = "GET_OPERATOR_TRIP_INQUIRY_LIST_ERROR";

export const GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_START = "GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_START";
export const GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_SUCCESS = "GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_SUCCESS";
export const GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_ERROR = "GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_ERROR";